import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Alert } from 'react-bootstrap';

const S3Uploader = require('react-s3-uploader');

export class Uploader extends Component {

    constructor(props){
        super(props);
        this.acceptString = this.props && this.props.validFileTypes && this.props.validFileTypes.length && this.props.validFileTypes.map((type) => '.' + type).join(',');
    }

    render() {
        const {
            getUploadUrl,
            onStart,
            onProgress,
            onFinish,
            onError,
            validTypesMessage,
            shouldDisable,
            inputId
        } = this.props;

        return (
                <div className="uploader">
                    <S3Uploader
                        getSignedUrl={getUploadUrl}
                        uploadRequestHeaders={{}}
                        preprocess={onStart}
                        onProgress={onProgress}
                        onFinish={onFinish}
                        onError={onError}
                        accept={this.acceptString}
                        disabled={shouldDisable}
                        id={inputId}
                    />
                    <p className="subtext">Only {validTypesMessage} files may be uploaded. Max allowed file size is 15MB.</p>
                </div>
        );
    }

}

Uploader.propTypes = {
    getUploadUrl: PropTypes.func,
    onStart: PropTypes.func,
    onProgress: PropTypes.func,
    onFinish: PropTypes.func,
    onError: PropTypes.func,
    validFileTypes: PropTypes.array,
    validTypesMessage: PropTypes.string,
    shouldDisable: PropTypes.bool,
    inputId: PropTypes.string
};

export default Uploader;
